/**
 * Format a phone number for display.
 * India (+91) shows bare number — it's the default and majority.
 * Any other country shows the country code prefix: "+971 501234567".
 */
export const formatPhoneDisplay = (
  phone: string | null | undefined,
  countryCode: string | null | undefined
): string => {
  if (!phone) return '';
  const cc = countryCode || '+91';
  if (cc === '+91') return phone;
  return `${cc} ${phone}`;
};

/**
 * Format a phone number for use in tel: links and outbound call APIs.
 * Always includes the country code with no space: "+971501234567".
 */
export const formatPhoneForTel = (
  phone: string | null | undefined,
  countryCode: string | null | undefined
): string => {
  if (!phone) return '';
  const cc = (countryCode || '+91').replace(/\s/g, '');
  return `${cc}${phone}`;
};

/**
 * @deprecated Use formatPhoneDisplay instead.
 * Kept for backward compatibility.
 */
export const formatPhoneNumber = (phoneNumber: string | number | null | undefined): string => {
  if (!phoneNumber) return '';
  const cleanNumber = String(phoneNumber).trim().replace(/^\+/, '').replace(/\s/g, '');
  if (!cleanNumber) return '';
  if (cleanNumber.length > 10) return `+${cleanNumber}`;
  return cleanNumber;
};
